import styled from '@emotion/styled';
import {Button, Chip, TextField} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;
export const TagSelectionWrapper = styled.div`
    display: grid;
    grid-template-columns: 400px;
`;

export const TextInput = styled(TextField)`
    justify-content: center;
    align-self: center;
    align-items: stretch;
    flex-grow: 2;
`;

export const AddButton = styled(Button)`
    margin-left: 1rem;
    min-width: 120px;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

export const Tags = styled(StyledChipClickableArea)`
    margin-top: 0.5rem;
`;
